<template>
  <a
    class="flex justify-between md:flex-col md:items-center w-full my-2 bg-white px-4 py-3 md:px-6 md:py-6 rounded-10"
    href="#imt-search-modal"
    @click="trackItemClickout"
    type="button"
  >
    <div class="flex items-center pb-0 md:pb-4">
      <i class="rounded-4 flag" :class="`flag-${countryFrom?.toLowerCase()}`" />
      <strong>{{ currencyFrom }}</strong>
      <span class="mx-3 font-semibold">➜</span>
      <i class="rounded-4 flag" :class="`flag-${countryTo?.toLowerCase()}`" />
      <strong>{{ currencyTo }}</strong>
    </div>

    <span
      class="hidden md:flex btn btn-amber w-full text-15 md:text-17 font-semibold items-center justify-center self-end md:self-center h-9"
      >{{ $t('header.compare_providers') }}</span
    >
    <svg role="presentation" focusable="false" tabindex="-1" class="icon icon-md inline md:hidden"
       
      alt="compare"
      svg-inline
     xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><title>compare</title>
  <path fill="currentColor" d="M505 442.7L405.3 343c-4.5-4.5-10.6-7-17-7H372c27.6-35.3 44-79.7 44-128C416 93.1 322.9 0 208 0S0 93.1 0 208s93.1 208 208 208c48.3 0 92.7-16.4 128-44v16.3c0 6.4 2.5 12.5 7 17l99.7 99.7c9.4 9.4 24.6 9.4 33.9 0l28.3-28.3c9.4-9.4 9.4-24.6.1-34zM208 336c-70.7 0-128-57.2-128-128 0-70.7 57.2-128 128-128 70.7 0 128 57.2 128 128 0 70.7-57.2 128-128 128z"/>
</svg>
  </a>
</template>
<script lang="ts" setup>
import type { Country } from '@core/plugins/master-data/types'
import { NavigationItemClick } from '@core/analytics/core-events/navigation'

const { $cookie, $masterData, $track } = useNuxtApp()

const countryFrom = ref<string | null>(null)
const currencyFrom = ref<string | null>(null)
const countryTo = ref<string | null>(null)
const currencyTo = ref<string | null>(null)

onMounted(() => {
  countryFrom.value = ($cookie.value.getGeoLoc() ?? '').toUpperCase()
  countryTo.value = getCountry(countryFrom.value)?.defaultCountryTo.iso ?? null
  currencyFrom.value = getCountry(countryFrom.value)?.defaultCurrency.iso ?? null
  currencyTo.value = getCountry(countryTo.value)?.defaultCurrency.iso ?? null
})

function getCountry(country: string | null | undefined): Country | undefined {
  return $masterData.countries.get(country ?? '')
}

async function trackItemClickout() {
  await $track(NavigationItemClick('#imt-search-modal', 'header', 'SearchFormCTA'))
}
</script>
